import { tutoresApi, wompiPagosApi } from '../../services/api';

export const useWompiModel = () => {

  const obtenerFirmaIntegridad = async(referencia,montoEnCentavos) =>{
    try{
      console.log("obtener firma integrdidad",referencia,montoEnCentavos);
      const response = await wompiPagosApi.obtenerFirmaIntegral(referencia,montoEnCentavos);
      return response;
    }
    catch(error){
      console.error("Error obteniendo firma:", error);
      return null;
    }
  }

  return{
    obtenerFirmaIntegridad,
  }

}